module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Export-9bc95429096b03abaea975d8becf7739.svg";